/**
 * Whether the given URL is a PDF route (`/pdf` or `-pdf`).
 * Kept free of Vue/composable imports so Vuex user store can call it without
 * pulling `usePdf` → settings → user circular initialization.
 */
export function getIsPdf(url?: string): boolean {
  return Boolean(url?.includes('/pdf') || url?.includes('-pdf'));
}
